'use es6';

export const MAIN_CONTENT_ANCHOR = 'main-content-anchor';